import React from 'react';

interface PackageSelectorProps {
  selectedPackage: 'webapp' | 'app' | 'both';
  setSelectedPackage: (pkg: 'webapp' | 'app' | 'both') => void;
}

const PackageSelector: React.FC<PackageSelectorProps> = ({ selectedPackage, setSelectedPackage }) => {
  const packages = [
    {
      id: 'webapp',
      title: 'Webapp',
      price: '€795,-',
      features: [
        'Toegankelijk vanuit elke browser',
        'Volledig responsive design',
        'Basis design (UI/UX)',
        'Basis back-end & database',
      ],
      icon: '/icon-website.png',
    },
    {
      id: 'app',
      title: 'App',
      price: '€995,-',
      features: [
        'Android of iOS',
        'Basis design (UI/UX)',
        'Eenvoudige integraties',
        'Basis back-end',
      ],
      icon: '/Icons/icon-mobile.png',
      popular: true,
    },
    {
      id: 'both',
      title: 'Website + App',
      price: '€1.250,-',
      features: [
        'Alles van App',
        'Website (tot 5 pagina\'s)',
        'Website incl. contactformulier',
        'Bundelkorting',
      ],
      icon: '/Icons/icon-both.png',
    },
  ];

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-center">
        <div className="flex-1 h-px bg-gray-300"></div>
        <h2 className="text-4xl font-bold text-blue-900 text-center px-6">Kies Jouw Pakket</h2>
        <div className="flex-1 h-px bg-gray-300"></div>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {packages.map((pkg) => (
          <div
            key={pkg.id}
            className={`relative rounded-2xl overflow-hidden cursor-pointer transition transform hover:scale-105 ${
              selectedPackage === pkg.id
                ? 'ring-4 ring-orange-500 shadow-2xl'
                : 'shadow-lg hover:shadow-xl'
            }`}
            onClick={() => setSelectedPackage(pkg.id as any)}
          >
            {pkg.popular && (
              <div
                className="absolute -top-2 left-1/2 transform -translate-x-1/2 text-white px-4 py-1 rounded-full text-sm font-semibold z-10"
                style={{
                  background: 'radial-gradient(circle at center, #ff8a3d 0%, #f06c28 45%, #d4551b 100%)'
                }}
              >
                Meest Gekozen
              </div>
            )}

            {/* Blue gradient header for mobile and both packages, light for website */}
            <div
              className={`py-4 px-6 relative overflow-hidden ${pkg.id === 'webapp' ? 'bg-gray-50' : ''}`}
              style={pkg.id !== 'website' ? {
                background: 'linear-gradient(135deg, #0e2a5a 0%, #1f4fa3 50%, #2c66c3 100%)',
              } : {}}
            >
              <div className={`flex items-center justify-center ${pkg.id === 'webapp' ? 'space-x-1' : 'space-x-3'} relative z-10`}>
                <img src={pkg.icon} alt={pkg.title} className={`object-contain ${pkg.id === 'webapp' ? 'w-12 h-12' : 'w-10 h-10'}`}/>
                <h3 className={`text-xl font-bold ${pkg.id === 'webapp' ? 'text-blue-900' : 'text-white'}`}>
                  {pkg.title}
                </h3>
              </div>
            </div>

            {/* Content area with UnderCardBCKGROUND for all cards */}
            <div
              className="p-6 flex flex-col"
              style={{
                backgroundImage: `url('/card-background.webp')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                minHeight: '400px',
              }}>
              <div className="text-center mb-6">
                <span className="text-sm text-gray-500">Vanaf</span>
                <p className="text-3xl font-bold text-orange-500">{pkg.price}</p>
              </div>

              <ul className="space-y-3 flex-grow">
                {pkg.features.map((feature, index) => (
                  <li key={index} className="flex items-start">
                    <svg
                      className="w-5 h-5 text-orange-500 mr-2 mt-1 flex-shrink-0"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>

              <button
                className="mt-6 w-full py-3 rounded-lg font-semibold transition text-white"
                style={{
                  background: 'radial-gradient(circle at center, #ff8a3d 0%, #f06c28 45%, #d4551b 100%)',
                  opacity: selectedPackage === pkg.id ? 1 : 0.9
                }}
              >
                {selectedPackage === pkg.id ? 'Geselecteerd ✓' : 'Kies Pakket'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PackageSelector;